import React, { Component, createRef } from 'react'
import './popup.css';
import { connect } from 'react-redux';
import { API } from '../../../constants';
import { detectClickOutSide as clickOutside } from '../../../utils'
import { withRouter } from 'react-router-dom';
import _ from "lodash";

export class PopupPromotion extends Component {
    constructor(props) {
        super(props)
        this.state = {
            visible : true,
            popupPromotionRef: createRef(),
            displayItem: null,
            imageLoaded: false
        }
    }

    componentDidMount() {
        clickOutside(this.state.popupPromotionRef, this.closeModal).didMount();
        let oneday = new Date() 
        let values = oneday.getTime();

        let shownPopup = JSON.parse(localStorage.getItem("popupPromotion"));

        if (values >= shownPopup?.time) {
            localStorage.removeItem("popupPromotion");
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(prevProps.popupPromotion, this.props.popupPromotion)) {
            const { popupPromotion } = this.props;

            let shownPopup = JSON.parse(localStorage.getItem("popupPromotion"));

            let showItems = popupPromotion?.filter(item => !shownPopup?.items.includes(item.image));

            if (!showItems?.length > 0) {
                localStorage.removeItem("popupPromotion");
                shownPopup = null;
                showItems = popupPromotion;
            } else {
                let displayItem = showItems[0];
                let midnigth = new Date().setHours(24, 0, 0, 0);
                localStorage.setItem(
                    "popupPromotion", 
                    JSON.stringify(shownPopup 
                        ? { ...shownPopup, items: [ ...shownPopup.items, displayItem.image ] }
                        : { time: midnigth, items: [ displayItem.image ] }
                    )
                );
                this.setState({
                    displayItem
                });
            }
        }
    }

    componentWillUnmount() {
        clickOutside(this.state.popupPromotionRef, this.closeModal).willUnMount();
    }

    closeModal = () => {
        this.setState({visible:false})
    }

    handleImageLoaded() {
        this.setState({ imageLoaded: true });
    }

    handleImageErrored() {
        this.setState({ imageLoaded: false });
    }

    render() {
        const { visible, popupPromotionRef, displayItem, imageLoaded } = this.state;
        const { history, basenameURL } = this.props;
        return (
            <>
                {
                    visible && displayItem && 
                    <div 
                        className="modal modal-popup-promotion in" 
                        style={{ display: imageLoaded ? 'flex': 'none' }} 
                        role="dialog" 
                        aria-hidden="true"
                    >
                        <div className="modal-dialog modal-dialog-centered modal-popup-dialog-promotion" style={{ marginTop: 0 }} role="document">
                            <div ref={popupPromotionRef} className="modal-content" >
                                <div>
                                    <i onClick={this.closeModal} className="fas fa-times-circle"></i>
                                    <img 
                                        src={`${API.POPUP_PROMOTION_IMG_URL}${displayItem.image}`}
                                        onLoad={this.handleImageLoaded.bind(this)}
                                        onError={this.handleImageErrored.bind(this)}
                                        onClick={() => displayItem.url
                                            ? displayItem.url.search('http') !== -1
                                            ? (window.location.href = displayItem.url)
                                            : history.push(`${basenameURL}${displayItem.url}`)
                                            : null}
                                        />
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </>
        )
    }
}

const mapStateToProps = ({ home, language }) => ({
    popupPromotion: home.popupPromotion,
    basenameURL: language.basenameURL
});

export default withRouter(connect(mapStateToProps)(PopupPromotion));

